export default "__VITE_ASSET__Cp5ndeNS__"